import gql from 'graphql-tag';

export const GET_VECTOR_DOCUMENTS = gql`
  query GetVectorDocuments(
    $category: String
    $status: String
    $verified: Boolean
    $search: String
    $limit: Int
    $offset: Int
  ) {
    vectorDocumentsPaged(
      category: $category
      status: $status
      verified: $verified
      search: $search
      limit: $limit
      offset: $offset
    ) {
      nodes {
        id
        title
        body
        url
        category
        tags
        applicableContexts
        industryTags
        status
        documentType
        expertiseLevel
        documentPurpose
        language
        verified
        lastVerifiedAt
        qualityScore
        usageCount
        lastAccessedAt
        public
        companyWide
        allowedRoles
        expiresAt
        sourceUrl
        sourceType
        citable
        embeddingGenerated
        createdAt
        updatedAt
        uploadedBy {
          id
          name
        }
      }
      totalCount
      activeCount
      verifiedCount
      withEmbeddingsCount
      citableCount
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const GET_VECTOR_DOCUMENT = gql`
  query GetVectorDocument($id: ID!) {
    vectorDocument(id: $id) {
      id
      title
      body
      url
      category
      tags
      applicableContexts
      industryTags
      status
      documentType
      expertiseLevel
      documentPurpose
      language
      verified
      lastVerifiedAt
      qualityScore
      usageCount
      lastAccessedAt
      public
      companyWide
      allowedRoles
      expiresAt
      relevanceDecayRate
      sourceUrl
      sourceType
      citable
      metadata
      embeddingGenerated
      createdAt
      updatedAt
      uploadedBy {
        id
        name
      }
    }
  }
`;

export const GET_VECTOR_DOCUMENT_CATEGORIES = gql`
  query GetVectorDocumentCategories {
    vectorDocumentCategories
  }
`;

export const RAG_TEST_SEARCH = gql`
  query RagTestSearch($query: String!, $limit: Int) {
    ragTestSearch(query: $query, limit: $limit) {
      similarityScore
      documentSimilarity
      bestChunkSimilarity
      matchedViaChunks
      document {
        id
        title
        body
        url
        category
        tags
        status
        verified
        citable
        embeddingGenerated
        createdAt
        metadata
      }
    }
  }
`;
